import { render, staticRenderFns } from "./NationalIdInfo.vue?vue&type=template&id=3b3a7d54&scoped=true"
import script from "./NationalIdInfo.vue?vue&type=script&lang=js"
export * from "./NationalIdInfo.vue?vue&type=script&lang=js"
import style0 from "./NationalIdInfo.vue?vue&type=style&index=0&id=3b3a7d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a7d54",
  null
  
)

/* custom blocks */
import block0 from "./NationalIdInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports